import { render, staticRenderFns } from "./TradingOperationItem.vue?vue&type=template&id=296bcdae&scoped=true"
import script from "./TradingOperationItem.vue?vue&type=script&lang=js"
export * from "./TradingOperationItem.vue?vue&type=script&lang=js"
import style0 from "./TradingOperationItem.vue?vue&type=style&index=0&id=296bcdae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296bcdae",
  null
  
)

export default component.exports